<template>
  <v-data-table
    v-bind="tableProps"
    dense
    :headers="headers"
    :items="data"
    :loading="loading"
    @click:row="onRowClick"
  >
    <template v-slot:[`item.warehouse_id`]="{ item }">
      {{ item.warehouse_id[1] }}
    </template>
    <template v-slot:[`item.warehouse_reason`]="{ item }">
      {{ item.warehouse_reason.count }}
      ({{ formatCurrency(item.warehouse_reason.total_amount) }})
    </template>
    <template v-slot:[`item.customer_reason`]="{ item }">
      {{ item.customer_reason.count }}
      ({{ formatCurrency(item.customer_reason.total_amount) }})
    </template>
  </v-data-table>
</template>

<script>
import { inject } from "vue-demi";
import { useDataTable } from "@/composables/api/data-table.js";

export default {
  setup() {
    const { data, loading, headers, tableProps } =
      useDataTable("orders_failed");

    const showOnMap = inject("showOnMap");

    const onRowClick = item => {
      showOnMap({
        measure: "delivery_loose",
        warehouse_id: item.warehouse_id[0]
      });
    };

    return {
      data,
      loading,
      headers,
      onRowClick,
      tableProps
    };
  }
};
</script>

<style></style>
